import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth0Service } from '../services/auth0Service';
import toast from 'react-hot-toast';

const Callback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        if (error) {
          console.error('Auth0 error:', error, errorDescription);
          toast.error(`Authentication failed: ${errorDescription || error}`);
          navigate('/login');
          return;
        }

        if (!code) {
          console.error('No authorization code received');
          toast.error('Authentication failed: No authorization code received');
          navigate('/login');
          return;
        }

        // Handle the callback
        await auth0Service.handleCallback(code);
        
        // Get the intended destination
        const redirectPath = localStorage.getItem('auth_redirect') || '/app/dashboard';
        localStorage.removeItem('auth_redirect');
        
        toast.success('Login successful!');
        navigate(redirectPath, { replace: true });
        
      } catch (error) {
        console.error('Callback error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-blue-800 flex items-center justify-center">
      <div className="text-center text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold">Completing authentication...</h2>
        <p className="text-blue-100 mt-2">Please wait while we complete your login.</p>
      </div>
    </div>
  );
};

export default Callback; 